
export const supportedLanguages = ['en', 'zh-CN'] as const

export type SupportedLanguage = (typeof supportedLanguages)[number]

export const defaultLanguage: SupportedLanguage = 'zh-CN'

export const languageStorageKey = 'gs-fe.language'

export const defaultNS = 'main'

export const ns = [
  'main',
  'vessel-tracking',
  'document',
] as const
